import ApiService from './ApiService.js'

export default {
  find (params, subresource = '') {
    return ApiService.get('reports', subresource, params)
  }
}
